<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div class="flex flex-col shadow bg-card">

        <!-- Cover image -->
        <div>
            <img
                class="h-20 lg:h-40 object-cover"
                src="assets/images/facturacion/banner_F.png"
                alt="Cover image">
        </div>

        <!-- User info -->
        <div class="flex flex-col flex-0 lg:flex-row items-center max-w-screen-xl w-full mx-auto px-8 lg:h-18 bg-card">

            <!-- Avatar -->
            <div class="-mt-26 lg:-mt-22 rounded-full">
                <div class="w-32 h-32 rounded-full ring-4 ring-bg-card perfil-letra" [ngStyle]="{'background-color': colorLetra}">
                    <span>{{ Inicial }}</span>
                </div>
                <!-- <img
                    class="w-32 h-32 rounded-full ring-4 ring-bg-card"
                    src="https://img.freepik.com/vector-premium/icono-vector-plano-empresa_9206-336.jpg"
                    alt="User avatar"> -->
            </div>

            <!-- Details -->
            <div class="flex flex-col items-center lg:items-start mt-4 lg:mt-0 lg:ml-8">
                <div class="text-lg font-bold leading-none">{{ FullName }}</div>
                <div class="text-secondary">{{ RFC }}</div>
            </div>

            <!-- Separator -->
            <!-- <div class="hidden lg:flex h-8 mx-8 border-l-2" style="display: none;"></div> -->

            <!-- Stats -->
            <!-- <div class="flex items-center mt-6 lg:mt-0 space-x-6" style="display: none;">
                <div class="flex flex-col items-center">
                    <span class="font-bold">200k</span>
                    <span class="text-sm font-medium text-secondary">FOLLOWERS</span>
                </div>
                <div class="flex flex-col items-center">
                    <span class="font-bold">1.2k</span>
                    <span class="text-sm font-medium text-secondary">FOLLOWING</span>
                </div>
            </div> -->

            <!-- Menu -->
            <!-- <div class="flex items-center mt-8 mb-4 lg:m-0 lg:ml-auto space-x-6" style="display: none;">
                <a
                    class="font-medium"
                    [routerLink]="['./']">
                    Home
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    About
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    Followers
                </a>
                <a
                    class="text-secondary"
                    [routerLink]="['./']">
                    Gallery
                </a>
            </div> -->

        </div>

    </div>

    <!-- Main -->
    <div class="p-6 sm:p-8">
        <div class="flex-auto -mt-px">
            <div class="w-full max-w-screen-xl mx-auto">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
                    <!-- Folios -->
                    <div class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden" style="background-color: #70c7ec;">
                        <div class="flex flex-col">
                            <div class="flex flex-row flex-wrap">
                                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 w-full min-w-0">
                                    <div class="flex flex-col">
                                        <div class="text-lg text-white dark:text-white">Folios Disponibles</div>
                                    </div>
                                    <div class="flex flex-col">
                                        <div class="text-3xl leading-none text-right font-bold text-white">{{resumen?.FoliosDisponibles}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Fecha de Vencimiento -->
                    <div class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden" style="background-color: #4960e6;">
                        <div class="flex flex-col">
                            <div class="flex flex-row flex-wrap">
                                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 w-full min-w-0">
                                    <div class="flex flex-col">
                                        <div class="text-lg text-white dark:text-white">Fecha de Vencimiento</div>
                                    </div>
                                    <div class="flex flex-col">
                                        <div class="text-3xl leading-none text-right font-bold text-white">{{resumen?.FechaVencimiento}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Facturado este mes -->
                    <div class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden" style="background-color: #350f9c;">
                        <div class="flex flex-col">
                            <div class="flex flex-row flex-wrap">
                                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 w-full min-w-0">
                                    <div class="flex flex-col">
                                        <div class="text-lg text-white dark:text-white">Facturado este mes</div>
                                    </div>
                                    <div class="flex flex-col">
                                        <div class="text-white text-3xl leading-none text-right font-bold">{{ resumen?.FacturadoMes | currency }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Cancelado este mes -->
                    <div class="flex flex-col flex-auto p-6 shadow rounded-2xl overflow-hidden" style="background-color: #6817b0;">
                        <div class="flex flex-col">
                            <div class="flex flex-row flex-wrap">
                                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 w-full min-w-0">
                                    <div class="flex flex-col">
                                        <div class="text-lg text-white dark:text-white">Cancelado este mes</div>
                                    </div>
                                    <div class="flex flex-col">
                                        <div class="text-white text-3xl leading-none text-right font-bold">{{ resumen?.CanceladoMes | currency }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Github issues summary -->
                    <div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="flex flex-col sm:flex-row items-start justify-between">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Documentos Recientes</div>
                            <div class="mt-3 sm:mt-0 sm:ml-2">
                                <mat-button-toggle-group
                                    value="this-week"
                                    #githubIssuesWeekSelector="matButtonToggleGroup">
                                    <mat-button-toggle value="this-week" (click)="redirect('factura/facturas')">Lista de Facturas</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                            <table
                                class="overflow-y-visible"
                                mat-table
                                [dataSource]="facturas?.rows">

                                <!-- Folio Factura -->
                                <ng-container
                                    matColumnDef="Serie"
                                    sticky>
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        Serie
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="flex items-center">
                                            <span
                                                class="w-2 h-2 rounded-full"
                                                [ngClass]="{'bg-blue-500': true}"></span>
                                            <span class="ml-3 leading-4">{{budget.serie}}</span>
                                        </span>
                                    </td>
                                </ng-container>
                                <!-- Folio Factura -->
                                <!--Nombre receptor factura -->
                                <ng-container matColumnDef="Folio">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        Folio
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.folio}}
                                        </span>
                                    </td>
                                </ng-container>

                                <!-- Folio Factura -->
                                <!--Nombre receptor factura -->
                                <ng-container matColumnDef="Tipo de Factura">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        Tipo de Factura
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.tipoFactura}}
                                        </span>
                                    </td>
                                </ng-container>

                                <!-- RFC receptor factura -->
                                <ng-container matColumnDef="RFC">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        RFC
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.rfc}}
                                        </span>
                                    </td>
                                </ng-container>
                                <!--Nombre receptor factura -->
                                <ng-container matColumnDef="Nombre">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        Nombre
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.nombre}}
                                        </span>
                                    </td>
                                </ng-container>
                                <!--Importe factura -->
                                <ng-container matColumnDef="Importe">
                                    <th
                                        mat-header-cell
                                        class="text-right pr-4"
                                        *matHeaderCellDef>
                                        Importe
                                    </th>
                                    <td
                                        mat-cell
                                        class="text-right pr-4"
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.importe}}
                                        </span>
                                    </td>
                                </ng-container>
                                <!-- FECHA FACTURA -->
                                <ng-container matColumnDef="Fecha">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef>
                                        Fecha
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let budget">
                                        <span class="font-small text-right">
                                            {{budget.fechaRegistro}}
                                        </span>
                                    </td>
                                </ng-container>
                                <!-- Expenses amount -->
                                <ng-container matColumnDef="Descargar PDF">
                                    <th mat-header-cell *matHeaderCellDef class="text-center">
                                        Descargar PDF
                                    </th>
                                    <td mat-cell *matCellDef="let budget" class="text-center">
                                        <ng-container>
                                            <button mat-stroked-button color="accent" (click)="descargarFactura(budget)">
                                                <mat-icon svgIcon="mat_outline:picture_as_pdf"></mat-icon>
                                            </button>
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="Descargar XML">
                                    <th mat-header-cell *matHeaderCellDef class="text-center">
                                        Descargar XML
                                    </th>
                                    <td mat-cell *matCellDef="let budget" class="text-center">
                                        <ng-container>
                                            <button mat-stroked-button color="accent" *ngIf="budget.xml_format" (click)="descargarxml(budget)">
                                                <mat-icon style="color: #999999;" svgIcon="mat_outline:file_copy"></mat-icon>
                                            </button>
                                        </ng-container>
                                    </td>
                                </ng-container>

                                <tr
                                    mat-header-row
                                    *matHeaderRowDef="facturas?.columns"></tr>
                                <tr
                                    mat-row
                                    *matRowDef="let row; columns: facturas?.columns;"></tr>
                            </table>

                            <div *ngIf="facturas?.rows.length === 0">
                                <div class="alert alert-primary" role="alert">
                                    <small>Aún no hay registros</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Budget details -->
                    <!-- <div class="sm:col-span-6 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden" *ngIf="formModo == 1">
                        <div class="text-lg font-medium tracking-tight leading-6 truncate">Lista de catalogos</div>
                        <div class="flex flex-col flex-auto mt-2 overflow-x-auto">

                        </div>
                    </div> -->

                    <!-- <button mat-raised-button color="primary" (click)="redirect('cuenta/perfil')">Perfil</button>
                    <button mat-raised-button color="primary" (click)="redirect('cuenta/paquetes')">Paquetes</button> -->
                    <!-- <button (click)="redirect()">Perfil</button> -->
                </div>
            </div>
        </div>
        
    </div>

</div>

